"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatesheetType = exports.isReportOnlyPropertyLandUse = exports.REPORT_ONLY_PROPERTY_LAND_USES = exports.PropertyLandUse = exports.LoanPurposeType = void 0;
// @TranslateToPython
var LoanPurposeType;
(function (LoanPurposeType) {
    LoanPurposeType["PURCHASE"] = "PURCHASE";
    LoanPurposeType["CASH_OUT_REFINANCE"] = "CASH_OUT_REFINANCE";
    LoanPurposeType["RATE_AND_TERM_REFINANCE"] = "RATE_AND_TERM_REFINANCE";
})(LoanPurposeType || (exports.LoanPurposeType = LoanPurposeType = {}));
// @TranslateToPython
var PropertyLandUse;
(function (PropertyLandUse) {
    PropertyLandUse["SingleFamily"] = "SingleFamily";
    // Underwriting prices and whitelists TAX EXEMPT separately from SFR (e.g. TX allows only SFR).
    PropertyLandUse["TaxExempt"] = "TaxExempt";
    PropertyLandUse["ResidentialNec"] = "ResidentialNec";
    PropertyLandUse["Condominium"] = "Condominium";
    PropertyLandUse["Cooperative"] = "Cooperative";
    PropertyLandUse["TwoToFourUnitProperty"] = "TwoToFourUnitProperty";
    // Materialized homes keep the unit count underwriting keys on; TwoToFourUnitProperty is a duplex there.
    PropertyLandUse["Triplex"] = "Triplex";
    PropertyLandUse["Quadruplex"] = "Quadruplex";
    PropertyLandUse["ManufacturedHome"] = "ManufacturedHome";
    PropertyLandUse["PlannedUnitDevelopment"] = "PlannedUnitDevelopment";
    PropertyLandUse["Townhouse"] = "Townhouse";
    PropertyLandUse["DetachedCondo"] = "DetachedCondo";
    PropertyLandUse["Other"] = "Other";
})(PropertyLandUse || (exports.PropertyLandUse = PropertyLandUse = {}));
// Distinctions only a property report (or ops) can make. Applicants state a 2-4 unit property with a unit count and
// never choose tax-exempt status, so these are never accepted as stated property types.
exports.REPORT_ONLY_PROPERTY_LAND_USES = [PropertyLandUse.TaxExempt, PropertyLandUse.Triplex, PropertyLandUse.Quadruplex];
const isReportOnlyPropertyLandUse = (propertyLandUse) => exports.REPORT_ONLY_PROPERTY_LAND_USES.some((reportOnlyPropertyLandUse) => reportOnlyPropertyLandUse === propertyLandUse);
exports.isReportOnlyPropertyLandUse = isReportOnlyPropertyLandUse;
// @TranslateToPython
var RatesheetType;
(function (RatesheetType) {
    RatesheetType["RocketCorrespondent"] = "RocketCorrespondent";
})(RatesheetType || (exports.RatesheetType = RatesheetType = {}));
